export const environment = {
  production: true,
  apiUrl: 'https://test-ghrkservice.com/api/v1',
  cmapURL: '/assets/lib/cmaps/', 
};
